module.exports = __webpack_public_path__ + "static/img/banner_home_01.6eeee2c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/resource/images/home/banner_home_01.png
// module id = vBd3
// module chunks = 10